module.exports = __webpack_public_path__ + "static/media/IMG_2409.9bad4b0b.png";